import { render, staticRenderFns } from "./FooterToolBar.vue?vue&type=template&id=b834ebf2&scoped=true&"
import script from "./FooterToolBar.vue?vue&type=script&lang=js&"
export * from "./FooterToolBar.vue?vue&type=script&lang=js&"
import style0 from "./FooterToolBar.vue?vue&type=style&index=0&id=b834ebf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b834ebf2",
  null
  
)

export default component.exports